module.exports = __webpack_public_path__ + "static/media/ami_es.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_es.png
// module id = 573
// module chunks = 1